__turbopack_context__.v({
  "enterYourEmail": "text-field1-module-scss-module__KZi3za__enterYourEmail",
  "error": "text-field1-module-scss-module__KZi3za__error",
  "errorText": "text-field1-module-scss-module__KZi3za__errorText",
  "label": "text-field1-module-scss-module__KZi3za__label",
  "row": "text-field1-module-scss-module__KZi3za__row",
  "textField": "text-field1-module-scss-module__KZi3za__textField",
});
